import React from 'react'
import { IStepConfig } from '../../../../context/subBuilder/types'
import Intro from './Intro'

interface Props {
  index: number
  stepConfig: IStepConfig
  className?: string | null
}

const SubBuilderStep: React.FunctionComponent<Props> = ({ index, stepConfig, children, className }) => {
  return (
    <div className="sub-builder-step-wrap">
      <Intro index={index} title={stepConfig.strings.title} introText={stepConfig.strings.intro} />
      <div className={`${className ? className : ''}`}>
        { children }
      </div>
    </div>
  )
}

export default SubBuilderStep